import React from 'react';
type PageType = 'home' | 'commercial' | 'services' | 'residential' | 'reservation' | 'cinema';
interface HeroServicesProps {
  onNavigate: (page: PageType) => void;
}
export function HeroServices({
  onNavigate
}: HeroServicesProps) {
  return <section id="hero" className="w-full bg-white py-6 md:py-12" data-id="element-114">
      <div className="max-w-6xl mx-auto px-6" data-id="element-115">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-6" data-id="element-116">
          {/* SLUŽBY Card */}
          <button onClick={() => onNavigate('services')} className="relative md:aspect-[4/3] overflow-hidden group cursor-pointer text-left" data-id="element-117">
            <div className="absolute inset-0 bg-gray-100 hidden md:block" data-id="element-118">
              <img src="https://cdn.magicpatterns.com/uploads/aFeewvzHWGmK4RBHjKzj43/42123269-4b82-40b2-9854-890acd95888e.png" alt="Služby" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" data-id="element-119" />
            </div>
            <div className="relative md:absolute inset-x-0 bottom-0 bg-black/70 py-4 px-4" data-id="element-120">
              <h3 className="text-white text-lg font-normal tracking-wide text-center" data-id="element-121">
                SLUŽBY
              </h3>
            </div>
          </button>

          {/* KOMERČNÍ ŘEŠENÍ Card */}
          <button onClick={() => onNavigate('commercial')} className="relative md:aspect-[4/3] overflow-hidden group cursor-pointer text-left" data-id="element-122">
            <div className="absolute inset-0 bg-gray-300 hidden md:block" data-id="element-123">
              <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&h=450&fit=crop&auto=format&q=80" alt="Komerční řešení" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" data-id="element-124" />
            </div>
            <div className="relative md:absolute inset-x-0 bottom-0 bg-black/70 py-4 px-4" data-id="element-125">
              <h3 className="text-white text-lg font-normal tracking-wide text-center" data-id="element-126">
                KOMERČNÍ ŘEŠENÍ
              </h3>
            </div>
          </button>

          {/* REZIDENČNÍ ŘEŠENÍ Card */}
          <button onClick={() => onNavigate('residential')} className="relative md:aspect-[4/3] overflow-hidden group cursor-pointer text-left" data-id="element-127">
            <div className="absolute inset-0 bg-gray-300 hidden md:block" data-id="element-128">
              <img src="https://images.unsplash.com/photo-1558002038-1055907df827?w=600&h=450&fit=crop&auto=format&q=80" alt="Rezidenční řešení" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" data-id="element-129" />
            </div>
            <div className="relative md:absolute inset-x-0 bottom-0 bg-black/70 py-4 px-4" data-id="element-130">
              <h3 className="text-white text-lg font-normal tracking-wide text-center" data-id="element-131">
                REZIDENČNÍ ŘEŠENÍ
              </h3>
            </div>
          </button>
        </div>
      </div>
    </section>;
}